import { formatDateTime } from "../../services/adminService";

function show(v) {
  if (v === null || v === undefined || v === "") return "—";
  if (typeof v === "object") {
    if (typeof v.toDate === "function") return formatDateTime(v);
    try {
      return JSON.stringify(v);
    } catch {
      return String(v);
    }
  }
  return String(v);
}

export default function RawDetails({ data }) {
  const entries = Object.entries(data || {});
  return (
    <dl className="na-raw">
      {entries.map(([k, v]) => (
        <div key={k}>
          <dt>{k}</dt>
          <dd>{show(v)}</dd>
        </div>
      ))}
    </dl>
  );
}
